<template>
  <div class="company-wrapper">
    <div v-if="company_logo" class="company-logo">
      <img :src="company_logo" />
    </div>
    <div class="title">{{ $tr('interview.landing.modules.feniche.title') }}</div>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'TalentqCompanyWrapper',

    props: {
      company_logo: {
        type: String,
        default: ''
      }
    }
  };
</script>

<style scoped lang="scss">
  .company-wrapper {
    .company-logo img {
      max-height: 60px;
      margin-bottom: 20px;
    }
  }
</style>
